import { render, staticRenderFns } from "./OrderManagementModal.vue?vue&type=template&id=1c848e42&"
import script from "./OrderManagementModal.vue?vue&type=script&lang=js&"
export * from "./OrderManagementModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderManagementModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports